<template>
  <div id="app">
    <QuizMaster />
  </div>
</template>

<script>
import QuizMaster from './components/QuizMaster.vue'

export default {
  name: 'app',
  components: {
    QuizMaster
  }
}
</script>

<style>
@font-face {
  font-family: 'boschsans';
  font-style:  normal;
  font-weight: 400;
  src: url('../src/assets/fonts/boschsans_regular.woff2'); 
}
@font-face {
  font-family: 'boschsans';
  font-style:  normal;
  font-weight: 600;
  src: url('../src/assets/fonts/boschsans_medium.woff2'); 
}
@font-face {
  font-family: 'boschsans';
  font-style:  normal;
  font-weight: 700;
  src: url('../src/assets/fonts/boschsans_bold.woff2'); 
}

#app {
  font-family: 'boschsans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 5px;
  background: #008ecf;
}

html {
  background: #008ecf;
}

</style>
